"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.consortiumSchemaDef = exports.consortiumSeriesSchemaDef = exports.consortiumComponentSchemaDef = void 0;
const internal_1 = require("./internal");
const general_1 = require("./general");
const joi_1 = __importDefault(require("joi"));
const util_1 = require("../util");
exports.consortiumComponentSchemaDef = {
    assessmentCode: internal_1.assessmentSchemaDef.code,
    number: internal_1.componentSchemaDef.number,
    assessmentVersion: internal_1.assessmentSchemaDef.version,
};
exports.consortiumSeriesSchemaDef = {
    businessUnitId: internal_1.businessUnitSchemaDef.id,
    id: internal_1.seriesSchemaDef.id,
};
exports.consortiumSchemaDef = Object.assign(Object.assign({}, general_1.daoObjSchemaDef), { centres: (0, util_1.arraySchema)(internal_1.centreBaseSchemaDef).required().min(1), components: (0, util_1.arraySchema)(exports.consortiumComponentSchemaDef).required().min(1), description: joi_1.default.string().optional(), name: joi_1.default.string().required(), series: (0, util_1.objectSchema)(exports.consortiumSeriesSchemaDef).required() });
